import React, { useEffect, useState } from 'react';
import { Card } from 'antd';
import LoanRepaymentForm from '../../components/LoanRepayment/LoanRepaymentForm';
import { useLoanRepayment } from '../../store/loanRepaymentContext';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 1. Add this import

const LoanRepaymentFormPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const { loanRepayments, fetchLoanRepayments } = useLoanRepayment();
    const [editLoanRepayment, setEditLoanRepayment] = useState<any | undefined>(undefined);
    const navigate = useNavigate();
    const { t } = useTranslation(); // 2. Use the translation hook

    useEffect(() => {
        fetchLoanRepayments();
    }, []);

    useEffect(() => {
        if (id) {
            const repayment = loanRepayments.find(r => r.id === id);
            setEditLoanRepayment(repayment);
        } else {
            setEditLoanRepayment(undefined);
        }
    }, [id, loanRepayments]);

    return (
        <div style={{ padding: 16 }}>
            <Card
                title={editLoanRepayment
                    ? t("loan_repayment_edit")
                    : t("loan_repayment_add")
                }
            >
                <LoanRepaymentForm
                    editLoanRepayment={editLoanRepayment}
                    onFinishEdit={() => navigate('/loan-repayments/list')}
                />
            </Card>
        </div>
    );
};

export default LoanRepaymentFormPage;
